import React, { useState, useEffect } from "react";
import FormConfiguration from "../../components/FormsManagement/FormConfiguraton/FormConfiguration";
import QuestionsPanel from "../../components/QuestionsPanel";
import {
  GeneralStyle,
  MenuItemWrapper,
  MenuWrapper,
  ConfigPanel,
} from "./FormCreationMain.styled";
import { ReactComponent as SettingsIcon } from "../../assets/svg/notepad-settings-icon.svg";
import { ReactComponent as QuestionIcon } from "../../assets/svg/question-icon.svg";
import { useHistory, useLocation } from "react-router-dom";
import FormPreviewPanel from "../FormPreviewPanel";
import { NotificationManager } from "react-notifications";
import {
  ADD_REMOVE_ADDITIONAL_DATA_FILE,
  ADD_REMOVE_ADDITIONAL_DATA_LIST,
  UPDATE_FORM_CONFIG,
  UPDATE_IS_MANDATORY_FILE,
  UPDATE_IS_MANDATORY_LIST,
} from "../../GraphQL/Mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import { clientPolicyIngsight } from "../../App";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AdditionalDataPanel from "../../components/AdditionalDataPanel/AdditionalDataPanel";
import {
  ADDITIONAL_DATA_LISTS,
  ADDITIONAL_DATA_QUESTIONS_BY_FORM,
} from "../../GraphQL/Queries";

const FormCreationMain = () => {
  const [selectedMenu, setSelectedMenu] = useState("settings");
  const [questionBlocks, setQuestionBlocks] = useState([]);
  const [formName, setFormName] = useState();
  const [formDescription, setFormDescription] = useState();
  const [citySelected, setCitySelected] = useState();
  const [lobSelected, setLobSelected] = useState([]);
  const [countrySelected, setCountrySelected] = useState();
  const [stateSelected, setStateSelected] = useState();
  const [formId, setFormId] = useState();
  const [formConfig, setFormConfig] = useState();
  const [action, setAction] = useState("create");
  const location = useLocation();
  const history = useHistory();
  const [renderAgain, setRenderAgain] = useState(false);
  const [additionalData, setAdditionalData] = useState([]);
  const [additionalDataPreview, setAdditionalDataPreview] = useState([]);
  const [updateFormConfig] = useMutation(UPDATE_FORM_CONFIG, {
    client: clientPolicyIngsight,
  });
  const [addRemoveAdditionalDataList] = useMutation(
    ADD_REMOVE_ADDITIONAL_DATA_LIST,
    {
      client: clientPolicyIngsight,
    }
  );
  const [updateIsMandatoryList] = useMutation(UPDATE_IS_MANDATORY_LIST, {
    client: clientPolicyIngsight,
  });
  const [addRemoveAdditionalDataFile] = useMutation(
    ADD_REMOVE_ADDITIONAL_DATA_FILE,
    {
      client: clientPolicyIngsight,
    }
  );
  const [updateIsMandatoryFile] = useMutation(UPDATE_IS_MANDATORY_FILE, {
    client: clientPolicyIngsight,
  });
  const [runQueryAdditionalDataLists] = useLazyQuery(ADDITIONAL_DATA_LISTS, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data.additionalDataLists) {
        setAdditionalData([...data.additionalDataLists]);
      }
    },
  });
  const [runQueryAdditionalDataQuestionsByForm] = useLazyQuery(
    ADDITIONAL_DATA_QUESTIONS_BY_FORM,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data.additionalDataQuestionsByForm) {
          setAdditionalDataPreview([...data.additionalDataQuestionsByForm]);
        }
      },
    }
  );

  useEffect(() => {
    runQueryAdditionalDataLists();
  }, []);

  useEffect(() => {
    if (formId) {
      runQueryAdditionalDataQuestionsByForm({
        variables: {
          formId: formId,
        },
      });
    }
  }, [formId, renderAgain]);

  useEffect(() => {
    if (location?.state?.form) {
      let { name, description, idForm } = location.state.form;
      setFormName(name);
      setFormDescription(description);
      setFormId(idForm);
      if (location?.state?.action === "edit") {
        setAction(location.state.action);
        let locationObj = location.state.form?.city;
        if (locationObj?.countryId) setCountrySelected(locationObj.countryId);
        if (locationObj?.cityId) setCitySelected(locationObj.cityId);
        if (locationObj?.stateId) setStateSelected(locationObj?.stateId);
        if (location.state.form?.lobs) {
          let lobIds = location.state.form.lobs.map((e) => {
            let obj = {};
            obj["value"] = e.lobid;
            obj["label"] = e.name;
            return obj;
          });
          setLobSelected(lobIds);
        }
        if (location.state.form?.jsonConfiguration) {
          setFormConfig(JSON.parse(location.state.form?.jsonConfiguration));
        }
      }
    }
  }, [location?.state?.form]);

  const handleSaveFormConfigurations = (config) => {
    if (formName && formDescription && citySelected && lobSelected.length > 0) {
      updateFormConfig({
        variables: {
          idForm: formId,
          name: formName,
          description: formDescription,
          idCity: parseInt(citySelected),
          idLobs: lobSelected.map((e) => parseInt(e.value)),
          jsonConfiguration: config,
        },
      })
        .then((res) => {
          if (res?.data?.updateForm?.idForm) {
            NotificationManager.success(
              "Form configurations saved successfully"
            );
            history.push("/PolicyFormsManagement");
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning("Some of the form configuration is missing");
    }
  };

  let handleToggleCheckedAdd = (item, data, idForm, questionDetails) => {
    if (item !== "File" && data && idForm && questionDetails) {
      let additionalDataLists = questionDetails?.map((item) => {
        return {
          dataListSelected: item?.idPolicyFormAdditionalDataList,
          listTitle: item?.listTitle,
        };
      });
      addRemoveAdditionalDataList({
        variables: {
          formId: idForm,
          additionalDataLists: additionalDataLists,
        },
      })
        .then((res) => {
          if (res?.data?.addRemoveAdditionalDataList) {
            NotificationManager.success(
              "The additional data is saved successfully",
              "",
              5000
            );
            setRenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
    if (item === "File" && idForm) {
      addRemoveAdditionalDataFile({
        variables: {
          formId: idForm,
        },
      })
        .then((res) => {
          if (res?.data?.addRemoveAdditionalDataFile) {
            NotificationManager.success(
              "The additional data file is saved successfully",
              "",
              5000
            );
            setRenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleMandatory = (name, listId, idForm, isMandatory) => {
    if (name !== "File" && listId && idForm) {
      updateIsMandatoryList({
        variables: {
          formId: idForm,
          isMandatory: isMandatory,
          listId: listId,
        },
      })
        .then((res) => {
          if (res?.data?.updateIsMandatoryList) {
            NotificationManager.success(
              "The mandatory field is successfully updated",
              "",
              5000
            );
            setRenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
    if (name === "File" && idForm) {
      updateIsMandatoryFile({
        variables: {
          formId: idForm,
          isMandatory: isMandatory,
        },
      })
        .then((res) => {
          if (res?.data?.updateIsMandatoryFile) {
            NotificationManager.success(
              "The mandatory field is successfully updated",
              "",
              5000
            );
            setRenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  const handleDisplayMenu = () => {
    switch (selectedMenu) {
      case "settings":
        return (
          <FormConfiguration
            formName={formName}
            setFormName={setFormName}
            formDescription={formDescription}
            setFormDescription={setFormDescription}
            countrySelected={countrySelected}
            setCountrySelected={setCountrySelected}
            stateSelected={stateSelected}
            setStateSelected={setStateSelected}
            citySelected={citySelected}
            setCitySelected={setCitySelected}
            lobSelected={lobSelected}
            setLobSelected={setLobSelected}
            action={action}
          />
        );
      case "questions":
        return (
          <QuestionsPanel
            idSurvey={formId}
            questionBlocks={questionBlocks}
            setQuestionBlocks={setQuestionBlocks}
            identity="form"
          />
        );
      case "additional-data":
        return (
          <AdditionalDataPanel
            idForm={formId}
            additionalData={additionalData}
            additionalDataPreview={additionalDataPreview}
            handleToggleCheckedAdd={handleToggleCheckedAdd}
            handleMandatory={handleMandatory}
          />
        );
      default:
        break;
    }
  };

  return (
    <GeneralStyle>
      <ConfigPanel>
        <MenuWrapper selectedMenu={selectedMenu}>
          <MenuItemWrapper
            id="settings"
            onClick={() => setSelectedMenu("settings")}
          >
            <SettingsIcon />
            Settings
          </MenuItemWrapper>
          <MenuItemWrapper
            id="questions"
            onClick={() => {
              setSelectedMenu("questions");
            }}
          >
            <QuestionIcon />
            Questions
          </MenuItemWrapper>
          <MenuItemWrapper
            id="additional-data"
            onClick={() => {
              setSelectedMenu("additional-data");
            }}
          >
            <AddBoxIcon />
            Additional Data
          </MenuItemWrapper>
        </MenuWrapper>
        <hr className="menu-hr" />
        {handleDisplayMenu()}
      </ConfigPanel>
      {
        <FormPreviewPanel
          idForm={formId}
          formName={formName}
          formConfig={formConfig}
          additionalDataPreview={additionalDataPreview}
          handleSaveFormConfigurations={handleSaveFormConfigurations}
          selectedMenu={selectedMenu}
        />
      }
    </GeneralStyle>
  );
};

export default FormCreationMain;
